'use strict';

import angular from 'angular';
import ngCookies from 'angular-cookies';

const femaleCookieName = 'sex_female';
const femaleCookieValue = '1';
const femaleRegexp = /^W/;

const fbCampaignHandlerFactory = ($location, $cookies) => {
  'ngInject';

  return () => {
    const utmContent = $location.search()['utm_content'];

    if (femaleRegexp.test(utmContent)) {
      const expires = new Date();
      expires.setMonth(expires.getMonth() + 1);

      const cookieOptions = {
        expires: expires,
        path: '/'
      };

      $cookies.put(femaleCookieName, femaleCookieValue, cookieOptions);
    }
  };
};

const dependencies = [
  ngCookies
];

export default angular
  .module('services.fbCampaignHandler', dependencies)
  .factory('fbCampaignHandler', fbCampaignHandlerFactory)
  .name;



// WEBPACK FOOTER //
// ./app/src/services/fb_campaign_handler.service.js